export enum AnalystProgressPhase {
  Thinking = 0,
  QueryingSensorData = 1,
  QueryingInspectionRecords = 2,
  QueryingLocationsDevices = 3,
  SearchingSamples = 4,
  SearchingSegs = 5,
  SearchingAgents = 6,
  SearchingLabResults = 7,
  SearchingRiskAssessments = 8,
  SearchingRiskRegisters = 9,
  SearchingOrganizationLevels = 10,
  AggregatingSamples = 11,
  SummarizingExceedances = 12,
  QueryingSensorReadings = 13,
  QueryingLatestReadings = 14,
  AggregatingSensorReadings = 15,
  ComparingSitesSensorReadings = 16,
  ListingParameters = 17,
}

export const ANALYST_PROGRESS_LABELS: Partial<Record<AnalystProgressPhase, string>> = {
  [AnalystProgressPhase.Thinking]: 'Analyzing your data…',
  [AnalystProgressPhase.QueryingSensorData]: 'Querying sensor data…',
  [AnalystProgressPhase.QueryingInspectionRecords]: 'Querying inspection records…',
  [AnalystProgressPhase.QueryingLocationsDevices]: 'Querying locations and devices…',
  [AnalystProgressPhase.SearchingSamples]: 'Searching samples…',
  [AnalystProgressPhase.SearchingSegs]: 'Searching SEGs…',
  [AnalystProgressPhase.SearchingAgents]: 'Searching agents…',
  [AnalystProgressPhase.SearchingLabResults]: 'Searching lab results…',
  [AnalystProgressPhase.SearchingRiskAssessments]: 'Searching risk assessments…',
  [AnalystProgressPhase.SearchingRiskRegisters]: 'Searching risk registers…',
  [AnalystProgressPhase.SearchingOrganizationLevels]: 'Searching organization levels…',
  [AnalystProgressPhase.AggregatingSamples]: 'Aggregating samples…',
  [AnalystProgressPhase.SummarizingExceedances]: 'Summarizing exceedances…',
  [AnalystProgressPhase.QueryingSensorReadings]: 'Querying sensor readings…',
  [AnalystProgressPhase.QueryingLatestReadings]: 'Querying latest readings…',
  [AnalystProgressPhase.AggregatingSensorReadings]: 'Aggregating sensor readings…',
  [AnalystProgressPhase.ComparingSitesSensorReadings]: 'Comparing sites…',
  [AnalystProgressPhase.ListingParameters]: 'Listing parameters…',
} satisfies Record<AnalystProgressPhase, string>;
